import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { TitledBody } from '../../common/components/TitledBody'
import { Grid } from '@mui/material'
import { usePrivilege } from '../../common/util/hooks'
import { FeaturePrivileges } from '../../common/util/featurePrivileges'
import { SectionedForm } from '../../common/components/SectionedForm'
import { useUsersSection } from './sections/useUsersSection'
import { useRolesSection } from './sections/useRolesSection'
import { RouteDefinition } from '../../app/App'
import { VpUserDetail } from './VpUserDetail'

export const vpUserDetailUrl = '/admin-management/users/:id'

export const AdminManagement = () => {
    const { t } = useTranslation()
    const { hasAccess: hasWriteAccess } = usePrivilege(FeaturePrivileges.enterpriseAdminMgmt.write)

    const usersSection = useUsersSection()
    const rolesSection = useRolesSection()

    const formSections = useMemo(() => [
        usersSection,
        rolesSection,
    ], [usersSection, rolesSection])

    return (
        <TitledBody title={t('admin-management.title')}>
            <Grid container>
                <Grid item xs={12} lg={10}>
                    <SectionedForm formSections={formSections} readOnly={!hasWriteAccess} />
                </Grid>
            </Grid>
        </TitledBody>
    )
}

export const routes: RouteDefinition[] = [
    {
        href: vpUserDetailUrl,
        component: VpUserDetail,
        id: 'admin-management-user-detail',
        parentId: 'admin-management-overview',
        menuId: 'admin-management-overview',
    },
]
